module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAABGdBTUEAALGPC/xhBQAAAEVQTFRFAAAAgL+/gIOHgIOHgYGIgIOGfoSHfoSHgIKFgIKHfoOGgIGFgIGHf4KGf4KGfoKGf4GFfoKFf4GGf4GFfoKGfoKGfoGFp/+gzwAAABZ0Uk5TAARASElKV1laaGmAjI21wsPi4+v8/im3M+cAAABxSURBVDjL3ZJJDoAgDEULzjIoU+9/VAcWShNronHjXz3SF/hJAfhZao9FfEMEMl8NIiDy58+FwSErqL32taAw9twTI8aW7eCx40tmfC9YeyMAPBdcXu8EMJ/J06+SpEx4kKvIlWYbmZKKCB2CFiX9JQsnVA3UGihVAAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/change-icon/icon_car@2x.png
// module id = tOOE
// module chunks = 1